/* eslint-disable no-unused-vars */

export enum UCSoundNames {
    NO_WIN_BEER_CAN = `noWinBeercan`,
    IDLE_BEER_CAN = `idleBeercan`,

    FREESPIN_MUSIC = `fs`,
    FS_INTRO_START = `fsIntroStart`,
    FS_INTRO_LOOP = `fsIntro`,
    FS_ON_CONTINUE = `fsStart`,
    FS_OUTRO_BELOW_STAKE = `fsEndBad`,
    FS_OUTRO_WIN = `fsEndGood`,
    EXTRA_SPINS_WON = `plus2Spins`,

    SUPER_FREESPIN_MUSIC = `sfs`,
    SFS_INTRO_START = `sfsIntroStart`,
    SFS_INTRO_LOOP = `sfsIntro`,
    SFS_OUTRO_WIN = `sfsEndGood`,

    BIG_FISH_SPIN = `bigberthaSpin`,
    BIG_FISH_LAND = `bigberthaLand`,
    BIG_FISH_ABORD = `bigBerthaSpinAbort`,
    F1_LAND = `m4x2Land`,
    F2_LAND = `m4x5Land`,
    F3_LAND = `m4x25Land`,
    F4_LAND = `m4x100Land`,
    F5_LAND = `m4x250Land`,
    F6_LAND = `m4x1000Land`,
    F7_LAND = `m4x5000Land`,

    SILVER_WILD_LAND = `wildLand`,
    GOLD_WILD_LAND = `wildGoldLand`,
    WILD_CATCH_FISH_01 = `fishSendtoWild01`,
    WILD_CATCH_FISH_02 = `fishSendtoWild02`,
    WILD_CATCH_FISH_03 = `fishSendtoWild03`,
    WILD_GOLD_COLLECT = `wildGoldCollect`,
    WILD_GOLD_COLLECT_BIG = `wildGoldCollectBig`,
    WILD_GOLD_COUNTER = `wildGoldCollectTick`,
    WILD_GOLD_COLLECT_END = `wildGoldCollectEnd`,
    WILD_TO_BOAT = `wildGoldSend`,
    BOAT_FISH_1 = `multiplierUpQuarter`,
    BOAT_FISH_2 = `multiplierUpHalfway`,
    BOAT_FISH_3 = `multiplierUpFinal`,
    BOAT_MULTIPLIER_X2 = `multiplierUpx2`,
    BOAT_MULTIPLIER_X3 = `multiplierUpx3`,
    BOAT_MULTIPLIER_X10 = `multiplierUpx10`,
    BOAT_TO_WILD = `multiplierSendtoWild`,

    XWAYS_LAND = `xwaysLand`,
    XWAYS_EXPAND = `xwaysExpand`,

    AMBIENT_BIRD_01 = `ambGrainBird01`,
    AMBIENT_BIRD_02 = `ambGrainBird02`,
    AMBIENT_BIRD_03 = `ambGrainBird03`,
    AMBIENT_BIRD_04 = `ambGrainBird04`,
    AMBIENT_BURP_01 = `ambGrainBurp01`,
    AMBIENT_BURP_02 = `ambGrainBurp02`,
    AMBIENT_CAN_01 = `ambGrainCan01`,
    AMBIENT_CAN_02 = `ambGrainCan02`,
    AMBIENT_CAN_03 = `ambGrainCan03`,
    AMBIENT_CAN_04 = `ambGrainCan04`,

    SCATTER_ANTICIPATION = `scatterAnticipation`,
    SCATTER_ANTICIPATION_FAIL = `scatterAnticipationFail`,
    SCATTER_ANTICIPATION_WIN = `scatterAnticipationWin`,
    SCATTER_ANTICIPATION_LAND_1 = `scatterAnticipationLand01`,
    SCATTER_ANTICIPATION_LAND_2 = `scatterAnticipationLand02`,
    SCATTER_ANTICIPATION_LAND_3 = `scatterAnticipationLand03`,
    SCATTER_LANDING_1 = `scatter1Land`,
    SCATTER_LANDING_1_XBET = `scatter1LandXbet`,
    SCATTER_LANDING_2 = `scatter2Land`,
    SCATTER_LANDING_3 = `scatter3Land`,
    SCATTER_LANDING_4 = `scatter4Land`,
    SCATTER_LANDING_5 = `scatter5Land`,

    CONTINUE_BUTTON = `continueButton`,

    XBET_ON = `xbetOn`,
    XBET_OFF = `xbetOff`,

    BLOCKER_OPEN_1 = `enhancerOpen01`,
    BLOCKER_OPEN_2 = `enhancerOpen02`,
    BLOCKER_OPEN_3 = `enhancerOpen03`,
    BLOCKER_REVEAL = `enhancerRevealBounce`,
    BLOCKER_CLOSE = `enhancerClose`,

    REEL_LAND_1 = `reelLand01`,
    REEL_LAND_2 = `reelLand02`,
    REEL_LAND_3 = `reelLand03`,
    REEL_LAND_4 = `reelLand04`,
    REEL_LAND_5 = `reelLand05`,
    REEL_LAND_6 = `reelLand06`,
    REELS_SPIN = `reelsSpinning`,

    WIN_COUNTUP = `winCountup`,
    WIN_TINY = `winTiny`,
    WIN_SMALL = `winSmall`,
    WIN_FALLBACK_SMALL = `winFallbackSmall`,
    WIN_MEDIUM = `winMid`,
    WIN_LARGE = `winLarge`,
    WIN_FALLBACK_LARGE = `winFallbackLarge`,

    BIG_WIN_1 = `bigwin1`,
    BIG_WIN_2 = `bigwin2`,
    BIG_WIN_3 = `bigwin3`,
    BIG_WIN_4 = `bigwin4`,
    BIG_WIN_5 = `bigwin5`,
    BIG_WIN_INTRO = `bigwinIntro`,
    BIG_WIN_END = `bigwinEnd`,

    MAX_CAP_COUNTUP = `wincapCountup`,
    MAX_CAP_LOOP = `wincapLoop`,

    WIN_SWEEP = `winSweep`,
    M4_WIN_SWEEP = `winSweepM4`,

    MAIN_MUSIC = `background-music-main`,
    MAIN_AMBIENT = `amb-music`,

    AS_WIN = `asWin`,
    AS_WIN_BIG = `asWinBig`,
}

export enum UCFontsNames {
    UC_DEFAULT = `UCWinFont`,
    UC_WAYS = `UCWaysFont`,
    UC_MULTIPLIER = `UCMultiplierFont`,
}

export enum UCSpineNames {
    M1 = `spine/M1.json`,
    M2 = `spine/M2.json`,
    M3 = `spine/M3.json`,
    M5 = `spine/M5.json`,
    L1 = `spine/L1.json`,
    L2 = `spine/L2.json`,
    L3 = `spine/L3.json`,
    L4 = `spine/L4.json`,
    L5 = `spine/L5.json`,
    F1 = `spine/F1.json`,
    F2 = `spine/F2.json`,
    F3 = `spine/F3.json`,
    F4 = `spine/F4.json`,
    F5 = `spine/F5.json`,
    F6 = `spine/F6.json`,
    F7 = `spine/F7.json`,
    BIG_FISH = `spine/BF.json`,
    XBET = `spine/xbet.json`,
    SCATTER = `spine/S.json`,
    SILVER_WILD = `spine/W.json`,
    GOLD_WILD = `spine/W_FS.json`,
    ANTICIPATION = `spine/anticipation.json`,
    BIG_WIN_1 = `spine/lvl1.json`,
    BIG_WIN_2 = `spine/lvl2.json`,
    BIG_WIN_3 = `spine/lvl3.json`,
    BIG_WIN_4 = `spine/lvl4.json`,
    BIG_WIN_5 = `spine/lvl5.json`,
    MAX_CAP_WIN = `spine/lvl6.json`,
    LOGO = `spine/logo.json`,
    WIN_FRAME = `spine/winframe_separate.json`,
    MYSTERY = `spine/xways.json`,
    REEL_BLOCKER = `spine/locked_reel.json`,
    REEL_BLOCKER_ANTICIPATION = `spine/locked_reel_anticipation.json`,
    FS_BOAT_MULTIPLIER = `spine/boat_collect.json`,
    FS_FISH_1_6_BOARDS = `spine/multiplier_boards.json`,
    FS_FISH_7_BOARD = `spine/5000x.json`,
    FISH_TO_BOAT_MULTIPLIER = `spine/wildToBoatMultiplier.json`,
    BOAT_TO_WILD_MULTIPLIER = `spine/boatToWildMultiplier.json`,
    FS_INTRO = `spine/FS_intro.json`,
    SFS_INTRO = `spine/SFS_intro.json`,
    REEL_SEPARATORS = `spine/reel_hooks.json`,
    BEER_CAN = `spine/can_toss.json`,
    BACKGROUND_BUBBLES = `spine/bg_bubbles.json`,
    BACKGROUND_FISHES = `spine/bg_fish.json`,
    BOAT_MULTIPLIER_PARTICLES = `spine/mutiplier _explosion.json`,
}
